export const LAUNCH_DARKLY_FLAG_FALLBACK = {
  production: {
    main_branch_structure: false,
  },
  test: {
    main_branch_structure: false,
  },
}
